import { render, staticRenderFns } from "./ModalNovoCertificado.vue?vue&type=template&id=f48d10e0&scoped=true&"
import script from "./ModalNovoCertificado.vue?vue&type=script&lang=js&"
export * from "./ModalNovoCertificado.vue?vue&type=script&lang=js&"
import style0 from "./ModalNovoCertificado.vue?vue&type=style&index=0&id=f48d10e0&prod&lang=scss&"
import style1 from "./ModalNovoCertificado.vue?vue&type=style&index=1&id=f48d10e0&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f48d10e0",
  null
  
)

export default component.exports